import { useAtomValue } from 'jotai';
import { Box } from '@mui/material';
import Stack from '@mui/material/Stack';
import * as state from '@/components/AssetLabelling/state';
import * as globalState from '@/state';
import { Viewer } from './Viewer';
import { DataLoader } from './DataLoader';
import { Breadcrumb } from './Breadcrumb';
import { LeftToolbar } from './LeftToolbar';
import { GlobalSnackbar } from '../shared/Snackbar/GlobalSnackbar';
import { useGetStructure } from './hooks';
import { PageLoader } from '../shared/PageLoader';
import { useGetAllZones } from './hooks/useGetAllZones';
import { TopToolbar } from './TopToolbar';
import styled from 'styled-components';
import { SideDrawer } from '../shared/SideDrawer';
import { ParentContainer } from './styles';

type Props = {
  structureId: string;
};
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;
export const AssetLabelling = ({ structureId }: Props) => {
  const { isLoading: isLoadingStructure } = useGetStructure(structureId);
  const { isLoading: isLoadingZones } = useGetAllZones(structureId);

  const isLoading = isLoadingStructure && isLoadingZones;

  const structure = useAtomValue(state.structure);
  const zone = useAtomValue(globalState.selectedZone);
  const leftDrawerSize = 300;

  if (isLoading || !structure) {
    return (
      <Box sx={{ position: 'relative', top: '40vh' }}>
        <PageLoader />
      </Box>
    );
  }

  return (
    <Wrapper>
      <Container>
        <Box sx={{ overFlow: 'auto', height: '100%' }}>
          {structure && (
            <>
              <Box>
                <SideDrawer
                  isOpen={true}
                  handleOpen={() => {}}
                  position="left"
                  width={leftDrawerSize}
                >
                  <LeftToolbar />
                </SideDrawer>
              </Box>
              <Stack
                direction="column"
                spacing={0}
                alignItems="stretch"
                sx={{
                  marginLeft: `${leftDrawerSize}px`,
                }}
              >
                <Box sx={{ paddingBottom: 2 }}>
                  <Breadcrumb structure={structure ?? undefined} zone={zone} />
                </Box>

                <ParentContainer navbarHeight={0}>
                  <Container>
                    <DataLoader structureId={structure.id}>
                      <TopToolbar />
                      <Viewer />
                    </DataLoader>
                  </Container>
                </ParentContainer>
              </Stack>
            </>
          )}
        </Box>
        <GlobalSnackbar />
      </Container>
    </Wrapper>
  );
};
